import axios from 'axios';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { define } from '../data/globals'
import { useNotify } from './useNotify';

export function useToken() {
    // Redux
    const dispath = useDispatch()
    const [ authMsg, setAuthMsg ] = useState('')
    const { pushNotify } = useNotify()
    
    // Открыть доступ (сгенерировать токен на сервере)
    async function createToken() {
        try {
            const response = await axios({
                method: 'post',
                url: define.pathToAPI + '/access/',
                data: JSON.stringify({
                    command: 'create', // команда create - сгенерировать токен
                }),
            })// axios
            // console.log('response: ', response);
            
            // проверка ответа от access/index.php
            if(response.data.status === "created" && response.data.authToken) {
                localStorage.setItem('AuthToken', response.data.authToken)
                dispath({ type: 'SetAuthStatus', authStatus: 'created' })
                return true
            } else if (response.data.status === "await" && response.data.timeLeftMsg) {
                dispath({ type: 'SetAuthStatus', authStatus: 'await' })
                setAuthMsg(response.data.timeLeftMsg)
                return
            } else {
                dispath({ type: 'SetAuthStatus', authStatus: 'await' })
                return
            }

        } catch (e) {

            if(e.code === 'ERR_NETWORK') {
                // Нет подключения к серверу
                pushNotify( 'Ошибка.<br>Нет подключения к серверу', 'notifyOrange')
                console.log('Нет подключения к серверу')
                return
            }

            if(e === 'AxiosError: Request failed with status code 400') {
                console.log('Ошибка при создании токена.\nКод: 400\n(см. access/index.php)')
                alert('Ошибка (код: 400) (см.  консоль)')
                return
            } else {
                console.log(e)
                alert('Ошибка:\n' + e)
                return
            }
        } // try
    } // createToken


    // Проверяем права доступа (отправляем токен на проверку на сервер)
    async function checkPermissions(userToken) {
        if(!userToken) {
            console.log('\nВ функцию checkPermissions не передан userToken (обязательный параметр)\n ');
            userToken = ''
            // return
        }

        try {
            const response = await axios({
                method: 'post',
                url: define.pathToAPI + '/access/',
                data: JSON.stringify({
                    command: 'check', // команда check - провериить токен
                    userToken: userToken,
                }),
            })// axios
            // console.log('response: ', response);

            // проверка ответа от access/index.php
            switch(response.data.status){
                case "approved":
                    // console.log('status: approved')
                    dispath({ type: 'SetAuthStatus', authStatus: 'approved' })
                    return true
                    // break
                case "expired":
                    // console.log('status: expired')
                    dispath({ type: 'SetAuthStatus', authStatus: 'expired' })
                    return
                    // break
                case "denied":
                    // console.log('status: denied')
                    dispath({ type: 'SetAuthStatus', authStatus: 'denied' })
                    return
                    // break
                default:
                    dispath({ type: 'SetAuthStatus', authStatus: 'expired' })
                    return
                    // break
            }

        } catch (e) {

            if(e.code === 'ERR_NETWORK') {
                // Нет подключения к серверу
                pushNotify( 'Ошибка.<br>Нет подключения к серверу', 'notifyOrange')
                console.log('Нет подключения к серверу')
                return
            }

            if(e === 'AxiosError: Request failed with status code 400') {
                console.log('Ошибка при проверке токена\nКод: 400\n(см. access/index.php)')
                alert('Ошибка (код: 400) (см.  консоль)')
                return
            } else {
                console.log(e)
                alert('Ошибка:\n' + e)
                return
            }
        } // try

    } // checkPermissions


    return { authMsg, createToken, checkPermissions }
}